import { render, staticRenderFns } from "./PInput.vue?vue&type=template&id=8f801f16"
import script from "./PInput.vue?vue&type=script&lang=js"
export * from "./PInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports